export default __webpack_public_path__ + "static/media/bgTop.ff1fee24.png";